<template>
    <div class="org-chart-wrapper">
      <div class="attach-project" v-if="selectedTeamId && myTeams.some(t => t.id === selectedTeamId)">
          <v-select
            v-model="seledtedProject"
            :items="projects"
            label="Tuzilma/Loyiha biriktirish"
            density="compact"
            multiple
            variant="outlined"
            item-value="id"
            item-title="name"
            @blur="saveProjects"
          >
            <template #selection="{ item, index }">
              
              <!-- 2 tagacha ko‘rsatamiz -->
              <v-chip
                v-if="index < 1"
                size="small"
                class="truncate-chip mr-1"
                :title="item.title"
              >
                {{ item.title }}
              </v-chip>

              <!-- Qolganlari +N -->
              <v-chip
                v-else-if="index === 1"
                size="small"
                class="mr-1"
              >
                +{{ seledtedProject.length - 1 }}
              </v-chip>

            </template>
          </v-select>
      </div>
      <div
        class="org-chart-header d-flex justify-content-between align-items-center mb-2"
      >
        <div class="org-chart-title">
          <span class="badge bg-soft-primary text-primary me-2">E5–E8</span>
          <span class="text-muted small">Strukturaviy org chart</span>
        </div>

        <div class="teams-filter">
          <p style="margin: 0; width: 200px;">Jamoa tanglang:</p>
          <select v-model="selectedTeamId" class="teams-select">
          <option v-if="teams.length <= 0" value="" disabled style="color: red;">
            Jamoa mavjud emas, yangi jamoa yarating
          </option>

          <template v-else>
            <optgroup v-if="myTeams.length > 0" label="Mening jamoalarim">
              <option v-for="team in myTeams" :key="team.id" :value="team.id">
                {{ team.name }}
              </option>
            </optgroup>

            <optgroup v-if="joinedTeams.length > 0" label="Men ishtirok etayotgan jamoalar">
              <option v-for="team in joinedTeams" :key="team.id" :value="team.id">
                {{ team.name }}
              </option>
            </optgroup>
          </template>
        </select>
          <div style="position: relative; display: flex; align-items: center;">
            <button title="Yangi jamoa qo'shish" 
                    :class="['btn-add-team-round ml-2', showPointer ? 'pulse-animation' : '']" 
                    @click="showModal=true; showPointer=false">
              <i class="fa fa-plus"></i>
            </button>
            <div v-if="showPointer" class="pointer-tooltip-pulse">
              Yangi jamoa yarating
            </div>
            
            <!-- Clone team tugmasi faqat Birovning jamoasida (Joined structures) da bo'lsa va u yerda xodim sifatida o'zi mavjud bo'lsa chiqadi -->
            <button title="Tuzilmadan nusxa olish" 
                    class="btn-add-team-round ml-2" 
                    v-if="selectedTeamId"
                    @click="cloneModal = true; cloneTeamName = ''">
              <i class="fa fa-copy"></i>
            </button>
          </div>
          <!-- <button title="Loyihalarni biriktirish" class="btn-add-team-round ml-2" @click="projectModal=true">
            <i class="fa-solid fa-arrow-right-arrow-left"></i>
          </button> -->
          
          <v-dialog
            v-model="showModal"
            scrollable
            persistent
            :overlay="false"
            max-width="500px"
            transition="dialog-transition"
          >
            <div class="modal-content">
              <h3>Yangi jamoa nomi</h3>
              <form @submit.prevent="addTeam">
                <input type="text" v-model="newTeamName" placeholder="Jamoa nomi kiriting" required />
                <div class="modal-actions">
                  <button type="submit" class="btn-confirm">Qo‘shish</button>
                  <button class="btn-cancel" @click="showModal = false">Bekor qilish</button>
                </div>
              </form>
            </div>
          </v-dialog>

          <!-- Jamoa Nusxalash Modali -->
          <v-dialog
            v-model="cloneModal"
            scrollable
            persistent
            :overlay="false"
            max-width="500px"
            transition="dialog-transition"
          >
            <div class="modal-content">
              <h3>Jamoani Nusxalash</h3>
              <p style="font-size: 13px; color: #555; margin-bottom: 15px;">Sizning qaramog'ingizdagi bo'ysunuvchi xodimlar zanjiridan mutlaqo yangi, siz rahbar bo'lgan jamoa yaratiladi.</p>
              <form @submit.prevent="cloneTeam">
                <input type="text" v-model="cloneTeamName" placeholder="Yangi jamoa nomi" required />
                <div class="modal-actions">
                  <button type="submit" class="btn-confirm" :disabled="isCloning">
                     {{ isCloning ? 'Nusxa olinayapti...' : 'Nusxa olib Yaratish' }}
                  </button>
                  <button type="button" class="btn-cancel" @click="cloneModal = false">Bekor qilish</button>
                </div>
              </form>
            </div>
          </v-dialog>

          <v-dialog
            v-model="projectModal"
            scrollable
            persistent
            :overlay="false"
            max-width="1000px"
            transition="dialog-transition"
          >
            <div class="modal-content">
              <ProjectTeamExchange
                @close-modal="projectModal = false"
              />
            </div>
          </v-dialog>
        </div>

        <div class="controls btn-group-sm">
          <button
            class="layout-btn"
            :class="{ active: currentLayout === 'top' }"
            @click="changeLayout('top')"
          >
            <i class="mdi mdi-arrow-expand-up me-1"></i> Top
          </button>
          <button
            class="layout-btn"
            :class="{ active: currentLayout === 'right' }"
            @click="changeLayout('right')"
          >
            <i class="mdi mdi-arrow-expand-right me-1"></i> Right
          </button>
          <button
            class="layout-btn"
            :class="{ active: currentLayout === 'left' }"
            @click="changeLayout('left')"
          >
            <i class="mdi mdi-arrow-expand-left me-1"></i> Left
          </button>
          <button
            class="layout-btn"
            :class="{ active: currentLayout === 'bottom' }"
            @click="changeLayout('bottom')"
          >
            <i class="mdi mdi-arrow-expand-down me-1"></i> Bottom
          </button>
          <button
            class="layout-btn"
            @click="$emit('close-modal')"
          >
            <i class="fa fa-xmark me-1"></i> Yopish
          </button>
        </div>
      </div>

      <div v-if="selectedTeamId == null" style="position: absolute;left: 50%;top: 50%;transform: translate(-50%, -50%);">
        <div class="no-data-info">
          <div class="no-data-icon">📭</div>
          <h3>Ma’lumot topilmadi</h3>
          <p>
            Tanlangan jamoa bo‘yicha hozircha hech qanday ma’lumot mavjud emas.
          </p>
        </div>
      </div>
      <div v-show="selectedTeamId"
        ref="chartContainer"
        class="chart-container"
        :class="{
          'is-dragging': !!dragState.draggingId,
          'ctrl-pressed': isCtrlPressed
        }"
      ></div>
    </div>

    <v-dialog
      v-model="dialog"
      max-width="480px"
    >
      <v-card>
        <v-card-title
          class="d-flex align-center justify-space-between py-2 px-4"
        >
          <div class="d-flex align-center">
            <v-icon size="20" class="me-2 text-primary">
              mdi-account-plus-outline
            </v-icon>
            <span class="text-body-1">
              Yangi xodim qo‘shish
            </span>
          </div>
          <v-btn icon small variant="text" @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pt-2 pb-3 px-4">
          <div class="text-muted mb-2 small" v-if="selectedManager">
            Rahbar:
            <strong>{{ selectedManager.name }}</strong>
            <!-- <span class="text-muted"> ({{ selectedManager.position }})</span> -->
          </div>

          <v-text-field
            v-model="search.tabel"
            label="Email"
            placeholder="Masalan: A123, a123, 1234"
            dense
            clearable
            hide-details="auto"
            prepend-inner-icon="mdi-card-account-details-outline"
            @keyup.enter="findEmployee"
            :loading="search.loading"
          ></v-text-field>

          <v-btn
            color="primary"
            block
            class="mt-2 mb-3"
            :loading="search.loading"
            @click="findEmployee"
          >
            <v-icon left small>mdi-magnify</v-icon>
            Qidirish
          </v-btn>

          <v-alert
            v-if="search.error"
            type="error"
            dense
            class="mb-2"
          >
            {{ search.error }}
          </v-alert>

          <div
            v-if="search.result"
            class="employee-preview d-flex align-center pa-2"
          >
            <v-avatar size="44" class="me-3">
              <img style="width: 100%;" :src="userPhoto(search.result.avatar)" alt="">
            </v-avatar>
            <div class="flex-grow-1 text-truncate">
              <div class="fw-semibold text-truncate">
                {{ search.result.name + " " + search.result.lastname }}
              </div>
              <div class="text-muted text-truncate small">
                {{ search.result.position }}
              </div>
              <div class="text-muted text-truncate small">
                {{ search.result.department }}
              </div>
            </div>
          </div>
        </v-card-text>

        <v-card-actions class="py-2 px-4">
          <v-spacer></v-spacer>
          <v-btn text small @click="dialog = false">
            Bekor qilish
          </v-btn>
          <v-btn
            color="primary"
            small
            :disabled="!search.result || saveAddLoading"
            :loading="saveAddLoading"
            @click="attachFoundEmployee"
          >
            Biriktirish
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>
<script>
import api from "@/services/api";
import * as d3 from "d3";
import { OrgChart } from "d3-org-chart";
import Swal from "sweetalert2";
import ProjectTeamExchange from "./ProjectTeamExchange.vue";

export default {
    components: {
      ProjectTeamExchange
    },

    emits: [
      'close-modal'
    ],

    data() {
        return {
          currentUserId: this.$store.state.user?.id || null,
          prevSeledtedProject: null,
          seledtedProject: null,
          projects: [],
          projectModal: false,
          selectedTeamId: null,
          teams: [],
          chart: null,
          flatData: [],
          // 🔹 Default top layout
          currentLayout: "top",

          isCtrlPressed: false,
          dragState: {
              draggingId: null,
              currentTargetId: null,
              prevParentId: null,
          },
          keyHandlerBound: false,
          observer: null,
          dndRebindTimer: null,

          dialog: false,
          selectedManagerId: null,
          selectedManager: null,
          search: {
              tabel: "",
              loading: false,
              result: null,
              error: null,
          },
          saveAddLoading: false,
          showModal: false,      // modal ko‘rinishi
          newTeamName: "",
          showPointer: false,
          
          cloneModal: false,
          cloneTeamName: "",
          isCloning: false,
        }
    },
    methods: {
      async cloneTeam() {
        if (!this.cloneTeamName.trim()) return;
        this.isCloning = true;
        try {
          const res = await api.post('/clone-team', {
            target_team_id: this.selectedTeamId,
            new_team_name: this.cloneTeamName
          });

          await this.getTeams(); // Backend yangi ro'yxatni qaytarishi kerak
          
          if (res.data && res.data.team_id) {
             this.selectedTeamId = res.data.team_id;
          }
          
          this.cloneModal = false;
          Swal.fire({
            icon: "success",
            title: "Muvaffaqiyatli!",
            text: "Jamoa muvaffaqiyatli nusxalandi. Siz avlodlaringiz bilan birga markazlashtirildingiz.",
            showConfirmButton: false,
            timer: 2000,
          });
        } catch(e) {
          console.error("Cloning Error: ", e);
          Swal.fire("Xatolik", "Tuzilmadan nusxa olishda nosozlik yuz berdi", "error");
        } finally {
          this.isCloning = false;
        }
      },

      saveProjects() {
        if (JSON.stringify(this.prevSeledtedProject) !== JSON.stringify(this.seledtedProject)) {
          api.put('/update-project-team', {
            projects: this.seledtedProject,
            teamId: this.selectedTeamId,
          }, {meta: {al: false}})
          .then(res => {
            console.log('Projects saved:', res.data);
            this.prevSeledtedProject = [...this.seledtedProject]; // muvaffaqiyatli saqlashdan keyin yangilaymiz
          })
          .catch(err => {
            console.error('Save error:', err);
          });
        } else {
          console.log('No changes detected.');
        }
      },

      getMyProjects() {
        api.get('/my-projects')
        .then(res => {
          this.projects = res.data;
        })
      },

      getOrgProjects(newVal) {
        api.get('/get-organization-project', {
          params: {
            teamId: newVal
          }
        }).then(res => {
          this.seledtedProject = res.data
          this.prevSeledtedProject = [...this.seledtedProject]
        })
      },

      async addTeam() {
        await api.post('/create-team', {
          teamName: this.newTeamName
        }).then(res => {
          this.selectedTeamId = res.data.id;
        })
        Swal.fire({
          icon: "success",
          title: "Jamoa yaratildi",
          showConfirmButton: true,
          timer: 1400,
          didOpen: () => {
            document.querySelector('.swal2-container').style.zIndex = '99999';
          }
        });
        this.newTeamName = '',
        this.showModal = false,
        this.getTeams()
      },

      async getOrganization(teamId) {
        if (this.chart) {
          this.chart = null;
        }
        if (this.$refs.chartContainer) {
          this.$refs.chartContainer.innerHTML = "";
        }
        const data = (await api.get(`/organization-members/${teamId}`)).data;
        this.flatData = Array.isArray(data) ? data.map((d) => ({ ...d })) : [];

        this.chart = new OrgChart()
        .nodeHeight(() => 130)
        .nodeWidth(() => 340)
        .childrenMargin(() => 50)
        .compactMarginBetween(() => 32)
        .compactMarginPair(() => 26)
        .neighbourMargin(() => 26)
        .layout(this.currentLayout)
        .nodeContent((d) => {
            // console.log("Rendering node:", this.teams.find(t => t.id === this.selectedTeamId).name);
            const isMyTeam = this.myTeams.some(t => t.id === this.selectedTeamId);
            const childCount = this.flatData.filter(n => n.parentId == d.data.id).length;
            const isEditable = isMyTeam || String(d.data.id) === String(this.currentUserId) || this.getDescendants(this.currentUserId).has(String(d.data.id));
            const isDraggable = !isMyTeam && this.getDescendants(this.currentUserId).has(String(d.data.id));
            return `
            <div class="node-content uz-card-wrap ${isDraggable ? 'draggable-node' : ''}" title="${isDraggable ? "Ctrl + Drag — boshqa joyga ko'chirish" : ""}" 
                style="width:${d.width}px;height:${d.height}px;box-sizing:border-box;user-select:none;">
                
                <div class="uz-card">
                  <div class="uz-card__left">
                      <div class="uz-card__dept-code">
                        ${ childCount > 0 ? 
                          `<div>
                              #${childCount}
                            <span style="font-size: 6px;">xodimlar soni</span>
                          </div>` : 
                          `<div>
                            <span style="font-size: 6px;">Bo‘ysinuvchi xodimlar mavjud emas</span>
                          </div>`
                        }
                      </div>
                      <div class="uz-card__dept-label">Tuzilma</div>
                      <div class="uz-card__emp-count muted">Xodimlar boshqaruvi</div>
                  </div>

                  <div class="uz-card__right">
                      <div class="uz-card__top-row">
                        <div class="uz-card__avatar-wrap">
                            <img class="uz-card__avatar" src="${this.userPhoto(
                            d.data.avatar,
                            )}" alt="" />
                        </div>
                        <div class="uz-card__text">
                            <div class="uz-card__name" title="${d.data.name}">
                            ${d.data.name}
                            </div>
                            <div class="uz-card__position" title="${d.data.email}">
                            ${d.data.email}
                            </div>
                            <div class="uz-card__tabel" title="${d.data.tabel || ""}">
                            ${d.data.tabel ? `Tabel: ${d.data.tabel}` : ""}
                            </div>
                        </div>
                        ${isEditable ? `
                        <div class="uz-card__actions">
                            <button class="uz-btn icon-btn add-btn" data-id="${
                            d.data.id
                            }" title="Bo‘ysunuuvchi qo‘shish">
                            <i class="fa-solid fa-user-plus"></i>
                            </button>
                            ${String(d.data.parentId) !== 'null' ? `
                            <button class="uz-btn icon-btn delete-btn" data-id="${
                            d.data.id
                            }" title="Xodimni olib tashlash">
                            <i class="fa-solid fa-user-minus"></i>
                            </button>
                            ` : ''}
                        </div>
                        ` : ''}
                      </div>

                  </div>
                </div>
            </div>`;
        })
        .container(this.$refs.chartContainer)
        .data(this.flatData)
        .render()
        .fit();

        this.$nextTick(() => {
        this.attachDragAndDrop();
        this.setupMutationObserver();

        const container = this.$refs.chartContainer;
        container.addEventListener("click", (e) => {
            const addBtn = e.target.closest(".add-btn");
            const delBtn = e.target.closest(".delete-btn");

            if (addBtn) {
            const id = addBtn.dataset.id;
            this.onAddMember(id);
            }

            if (delBtn) {
            const id = delBtn.dataset.id;
            this.onDeleteMember(id);
            }
        });
        });
      },

      async getTeams() {
        await api.get('/teams')
        .then(res => {
          this.teams = res.data;
          // Agar foydalanuvchida umuman jamoa bo'lmasa, ko'rsatkichni qo'shamiz
          if (!this.myTeams || this.myTeams.length === 0) {
            this.showPointer = true;
          }
        })
      },

      onAddMember(id) {
        const manager = this.flatData.find((n) => String(n.id) === String(id)) || null;
        this.selectedManagerId = id;
        this.selectedManager = manager;
        this.search = {
            tabel: "",
            loading: false,
            result: null,
            error: null,
        };
          this.dialog = true;
      },

      async onDeleteMember(id) {
        const member = this.flatData.find((n) => n.id == id);
        const name = member?.name || `#${id}`;

        const children = this.flatData.filter(n => n.parentId == id);
        const hasChildren = children.length > 0;
        let isCascade = false;

        if (hasChildren) {
          const result = await Swal.fire({
            title: "Bo‘ysunuvchilar mavjud!",
            text: `Ushbu xodimning bo'ysunuvchi xodimlari mavjud. Ularni boshqa rahbarga o‘tkazasizmi yoki xodimni bo'ysunuvchilari (avlodlari) bilan birga butkul o‘chirasizmi?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Butkul o'chirish",
            cancelButtonText: "Bekor qilish",
            confirmButtonColor: "#d33",
            didOpen: () => {
                document.querySelector('.swal2-container').style.zIndex = '99999';
            }
          });
          if (result.isConfirmed) {
              isCascade = true;
          } else {
              return;
          }

        } else {
          const result = await Swal.fire({
            title: "Olib tashlamoqchimisiz?",
            text: `${name} tuzilmadan olib tashlanadi.`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Ha, olib tashla",
            cancelButtonText: "Bekor qilish",
            confirmButtonColor: "#d33",
            cancelButtonColor: "#6c757d",
            reverseButtons: true,
            didOpen: () => {
                document.querySelector('.swal2-container').style.zIndex = '99999';
            }
          });

          if (!result.isConfirmed) return;
        }

        try {
            await api.delete(`/delete-member/${member.id}`, {
              params: {
                team_id: this.selectedTeamId,
                cascade_delete: isCascade ? 1 : 0
              }
            });

            await this.reloadChartData();

            Swal.fire({
            icon: "success",
            title: "O‘chirildi",
            showConfirmButton: false,
            timer: 1400,
            });
        } catch (e) {
            console.error("Delete member failed:", e);
            Swal.fire("Xatolik", "Xodimni o‘chirishda xatolik yuz berdi.", "error");
        }
      },

      changeLayout(direction) {
        this.currentLayout = direction;
        if (this.chart) {
            this.chart.layout(direction).render().fit();
            this.$nextTick(this.attachDragAndDrop);
        }
      },

      userPhoto(avatar) {
        return `https://api.task-board.uz/storage/user/avatar/${avatar ?? 'user.png'}`;
      },

      applyDropCommitHighlight(targetId) {
      const root = d3.select(this.$refs.chartContainer);
      let matched = null;
      root.selectAll(".node").each(function (d) {
          if (d?.data?.id != null && String(d.data.id) === String(targetId)) {
          matched = d3.select(this);
          }
      });
      if (matched) {
          const card = matched.select(".node-content");
          card.classed("drop-commit", true);
          setTimeout(() => card.classed("drop-commit", false), 800);
      }
      },

      attachDragAndDrop() {
        const root = d3.select(this.$refs.chartContainer);
        const svg = root.select("svg");
        if (svg.empty()) return;

        const nodes = svg.selectAll(".node");

        const dragBehavior = d3
          .drag()
          .filter((event) => !!event.ctrlKey)
          .on("start", (event, d) => {
          this.dragState.draggingId = d.data.id;
          this.dragState.currentTargetId = null;
          this.dragState.prevParentId = d.data.parentId ?? null;

          const content = event.sourceEvent?.target?.closest?.(
              ".node-content",
          );
          if (content) content.classList.add("dragging");

          if (event.sourceEvent?.preventDefault)
              event.sourceEvent.preventDefault();
          })
          .on("drag", (event) => {
          const target = this.findNodeUnderPointer(event.sourceEvent);
          const targetId = target ? target.datum().data.id : null;

          if (this.dragState.currentTargetId !== targetId) {
              root.selectAll(".drop-target").classed("drop-target", false);
              if (
              targetId &&
              this.isValidDrop(this.dragState.draggingId, targetId)
              ) {
              d3.select(target.node())
                  .select(".node-content")
                  .classed("drop-target", true);
              }
              this.dragState.currentTargetId = targetId;
          }
          })
          .on("end", async (event) => {
          root.selectAll(".drop-target").classed("drop-target", false);
          root.selectAll(".dragging").classed("dragging", false);

          const target = this.findNodeUnderPointer(event.sourceEvent);
          const targetId = target ? target.datum().data.id : null;

          const sourceId = this.dragState.draggingId;
          const oldParent = this.dragState.prevParentId;

          this.dragState.draggingId = null;
          this.dragState.currentTargetId = null;
          this.dragState.prevParentId = null;

          if (!targetId) return;
          if (!this.isValidDrop(sourceId, targetId)) return;
          if (String(targetId) === String(oldParent)) return;

          const idx = this.flatData.findIndex(
              (n) => String(n.id) === String(sourceId),
          );
          if (idx === -1) return;

          this.flatData[idx] = { ...this.flatData[idx], parentId: targetId };

          this.chart.data(this.flatData).render().fit();
          this.$nextTick(() => {
          this.applyDropCommitHighlight(targetId);
          this.attachDragAndDrop()
          this.highlightDraggableNodes();
        });

        try {
            await this.saveUpdateMember(sourceId, targetId);
        } catch (e) {
            console.error("Persist failed:", e);
            this.flatData[idx] = { ...this.flatData[idx], parentId: oldParent };
            this.chart.data(this.flatData).render().fit();
            this.$nextTick(this.attachDragAndDrop);
        }
      });

      nodes.call(dragBehavior);

      if (!this.keyHandlerBound) {
          this.keyHandlerBound = true;
          window.addEventListener("keydown", this.handleKey);
          window.addEventListener("keyup", this.handleKey);
          window.addEventListener("blur", this.resetCtrlFlag);
      }
      },

      highlightDraggableNodes() {
        const myDescendants = this.getDescendants(this.currentUserId);
        const root = d3.select(this.$refs.chartContainer);

        root.selectAll(".node").each(function(d) {
          const nodeId = String(d.data.id);
          const content = d3.select(this).select(".node-content");
          
          if (myDescendants.has(nodeId)) {
            content.classed("draggable-node", true);
          } else {
            content.classed("draggable-node", false);
          }
        });
      },

      handleKey(e) {
      const pressed = !!e.ctrlKey;
      if (pressed !== this.isCtrlPressed) {
          this.isCtrlPressed = pressed;
      }
      },

      resetCtrlFlag() {
      this.isCtrlPressed = false;
      },

      findNodeUnderPointer(pointerEvent) {
      const root = d3.select(this.$refs.chartContainer);
      if (root.empty()) return null;

      let hit = null;
      root.selectAll(".node").each(function () {
        const el = this.querySelector(".node-content") || this;
        const bbox = el.getBoundingClientRect
        ? el.getBoundingClientRect()
        : { left: -1, right: -1, top: -1, bottom: -1 };

        if (
        pointerEvent.clientX >= bbox.left &&
        pointerEvent.clientX <= bbox.right &&
        pointerEvent.clientY >= bbox.top &&
        pointerEvent.clientY <= bbox.bottom
        ) {
        hit = d3.select(this);
        }
      });
      return hit;
      },

      isValidDrop(sourceId, targetId) {
        if (!sourceId || !targetId) return false;
        if (String(sourceId) === String(targetId)) return false;

        // Logged in user ning id si
        const myId = this.currentUserId; // auth user id

        // Faqat mening avlodlarim drag qilinishi mumkin
        const myDescendants = this.getDescendants(myId);
        if (!myDescendants.has(String(sourceId))) return false;

        // Target circular bo'lmasin (source ning o'z avlodiga drop qilib bo'lmaydi)
        const sourceDescendants = this.getDescendants(sourceId);
        if (sourceDescendants.has(String(targetId))) return false;

        return true;
      },

      getDescendants(nodeId) {
        const result = new Set();
        const queue = [String(nodeId)];
        while (queue.length > 0) {
          const current = queue.shift();
          const children = this.flatData.filter(n => String(n.parentId) === current);
          for (const child of children) {
            const childId = String(child.id);
            if (!result.has(childId)) {
              result.add(childId);
              queue.push(childId);
            }
          }
        }
        return result;
      },

      async saveUpdateMember(employeeId, newManagerId) {
      return api.post("/update-member", {
          team_id: this.selectedTeamId,
          user_id: employeeId,
          parent_id: newManagerId,
      }, {meta: {al:false}});
      },

      deferRebind() {
      clearTimeout(this.dndRebindTimer);
      this.dndRebindTimer = setTimeout(() => this.attachDragAndDrop(), 50);
      },

      setupMutationObserver() {
      const el = this.$refs.chartContainer;
      if (!el) return;

      this.observer = new MutationObserver((mutations) => {
          for (const m of mutations) {
          if (m.addedNodes && m.addedNodes.length) {
              this.deferRebind();
              break;
          }
          }
      });
      this.observer.observe(el, { childList: true, subtree: true });

      el.addEventListener("click", this.deferRebind, true);
      },

      async findEmployee() {
        if (this.flatData.some(d => d.tabel == this.search.tabel.toUpperCase())) {
          this.search.error = 'Ushbu xodim tuzilmada mavjud'
          this.search.result = null;
          return;
        }

        if (!this.search.tabel || !String(this.search.tabel).trim()) {
            this.search.error = "Emailni aniq va to‘liqroq kiriting";
            this.search.result = null;
            return;
        }
        this.search.loading = true;
        this.search.error = null;
        this.search.result = null;

        try {
            const res = await api.get("/find-user",
            { params: { search: this.search.tabel }, meta: {al:false} },
            );

            if (!res.data) {
            this.search.error = "Ko‘rsatilgan qiymat bo‘yicha xodim topilmadi.";
            } else {
            this.search.result = res.data;
            }
        } catch (e) {
            const status = e.response?.status;
            
            if (status === 422 || status === 404) {
                this.search.error = e.response.data.message;
            } else {
                this.search.error = "Qidirishda xatolik yuz berdi.";
            }
        } finally {
            this.search.loading = false;
        }
      },

      async attachFoundEmployee() {
        // Tuzilmada mavjud userni qo‘shishni oldini olish uchun tekshiruv
        if (this.flatData.some(d => d.id == this.search.result.id)) {
          const user = this.flatData.find(d => d.id == this.search.result.id);
          const managerName = this.flatData.find(d => d.id == user.parentId)?.name;
          this.search.error = 'Ushbu xodim tuzilmada mavjud. ' + (managerName ? `Rahbari: ${managerName}` : 'Rahbari aniqlanmagan');
          // this.search.result = null;
          return;
        }

        if (!this.search.result || !this.selectedManagerId) return;

        this.saveAddLoading = true;
        try {
            await api.post(`/teams/${this.selectedTeamId}/add-member`, {
              userId: this.search.result.id,
              parent_id: this.selectedManagerId
            });

            await this.reloadChartData();
            this.dialog = false;

            // Swal.fire({
            // icon: "success",
            // title: "Xodim qo‘shildi",
            // showConfirmButton: false,
            // timer: 1400,
            // });
        } catch (e) {
            console.error("attachFoundEmployee error:", e);
            Swal.fire(
            "Xatolik",
            "Xodimni biriktirishda xatolik yuz berdi.",
            "error",
            );
        } finally {
            this.saveAddLoading = false;
        }
      },

      async reloadChartData() {
        const data = (await api.get("/organization-members/" + this.selectedTeamId)).data;

        // ✅ Expand holatini saqlashning eng ishonchli usuli (d3-org-chart author usuli)
        const expandedIds = new Set();
        const collapsedIds = new Set(); // Xavfsizlik uchun yopiqlarni ham saqlaymiz
        
        if (this.chart && typeof this.chart.getChartState === 'function') {
            const state = this.chart.getChartState();
            if (state && state.allNodes) {
                state.allNodes.forEach(n => {
                    if (n.data && n.data.id != null) {
                        // n.expanded boolean sifatida d3 ierarxiyasida haqiqiy holatni bildiradi
                        if (n.expanded) {
                            expandedIds.add(String(n.data.id));
                        } else {
                            collapsedIds.add(String(n.data.id));
                        }
                    }
                });
            }
        }

        this.flatData = Array.isArray(data) ? data.map(d => {
            let isExpanded = true; 
            if (collapsedIds.has(String(d.id))) {
                isExpanded = false; // Agar aniq user yopgan bo'lsa false
            } else if (expandedIds.has(String(d.id))) {
                isExpanded = true; // Agar user aniq ochgan bo'lsa true
            } else {
                // Agar yangi element bo'lsa yoki topilmasa - default ochiq
                isExpanded = true;
            }

            return {
                ...d,
                _expanded: isExpanded
            };
        }) : [];

        if (this.chart) {
          // ✅ Mavjud chartni yangilash, yangi yaratmaslik
          this.chart
            .data(this.flatData)
            .render();
          
          this.$nextTick(() => this.attachDragAndDrop());
        }
      }


    },

    async mounted() {
      this.getTeams();
      this.getMyProjects();
    },

    computed: {
      myTeams() {
        return this.teams.filter(t => t.is_owner);
      },
      joinedTeams() {
        return this.teams.filter(t => !t.is_owner);
      }
    },

    watch: {
      async selectedTeamId(newVal, oldWal) {
        if (newVal != oldWal) {
          await this.getOrganization(newVal);
          this.getOrgProjects(newVal);
        }
      }
    },

    beforeUnmount() {
        window.removeEventListener("keydown", this.handleKey);
        window.removeEventListener("keyup", this.handleKey);
        window.removeEventListener("blur", this.resetCtrlFlag);
        if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
        }
        if (this.dndRebindTimer) {
        clearTimeout(this.dndRebindTimer);
        this.dndRebindTimer = null;
        }
        this.$refs.chartContainer?.removeEventListener(
        "click",
        this.deferRebind,
        true,
        );
    },
}
</script>
<style scoped>
.org-chart-wrapper {
  min-height: 80vh;
  margin-top: 4px;
  padding: 12px;
  border-radius: 16px;
  background: linear-gradient(180deg, #f9fafb 0%, #f3f4f6 100%);
  border: 1px solid rgba(148, 163, 184, 0.35);
}

.org-chart-header {
  margin-bottom: 6px;
}

.org-chart-title .badge {
  font-size: 0.7rem;
}

.controls {
  display: inline-flex;
  gap: 6px;
}

.layout-btn {
  border: 1px solid rgba(148, 163, 184, 0.8);
  border-radius: 999px;
  padding: 4px 10px;
  font-size: 0.75rem;
  background: #ffffff;
  color: #4b5563;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  transition: all 120ms ease;
}
.layout-btn i {
  font-size: 0.95rem;
}
.layout-btn:hover {
  background: #eef2ff;
  border-color: #6366f1;
  color: #111827;
}
.layout-btn.active {
  background: #2563eb;
  color: #ffffff;
  border-color: #1d4ed8;
}

.chart-container {
  margin-top: 6px;
  width: 100%;
  min-height: 480px;
  background: #ffffff;
  border-radius: 14px;
  border: 1px solid rgba(148, 163, 184, 0.3);
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.06);
  overflow: hidden;
  position: relative;
}

:deep(.draggable-node) {
  border: 1px solid #16a34a !important;
  border-radius: 15px !important;
  position: relative;
  box-shadow: 0 0 0 1px rgba(22, 163, 74, 0.15);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

:deep(.drag-hint-badge) {
  position: absolute;
  top: -11px;
  left: 50%;
  transform: translateX(-50%);
  background: linear-gradient(135deg, #4f46e5, #7c3aed);
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  padding: 3px 12px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  gap: 5px;
  white-space: nowrap;
  z-index: 10;
  box-shadow: 0 3px 8px rgba(79, 70, 229, 0.5);
  transition: background 0.2s ease, box-shadow 0.2s ease;
  animation: pulse-badge 2s infinite;
}

:deep(.drag-hint-badge i) {
  font-size: 10px;
}

@keyframes pulse-badge {
  0%, 100% { box-shadow: 0 3px 8px rgba(79, 70, 229, 0.5); }
  50%       { box-shadow: 0 3px 16px rgba(79, 70, 229, 0.85); }
}




/* foreignObject ichida pointer ishlashi uchun */
:deep(.chart-container svg .node foreignObject) {
  pointer-events: all;
}

/* ====== YANGI KARTA DIZAYNI ====== */

:deep(.uz-card) {
  width: 100%;
  height: 100%;
  border-radius: 14px;
  overflow: hidden;
  background: #ffffff;
  border: 1px solid rgba(148, 163, 184, 0.35);
  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.06);
  display: grid;
  grid-template-columns: 80px 1fr;
  box-sizing: border-box;
}

:deep(.uz-card__left) {
  background: radial-gradient(circle at top, #e0edff 0%, #d1e3ff 40%, #c7d2fe 100%);
  border-right: 1px solid rgba(129, 140, 248, 0.35);
  padding: 8px 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  color: #0b1f4a;
}

:deep(.uz-card__dept-code) {
  font-weight: 700;
  font-size: 14px;
  letter-spacing: 0.04em;
  padding: 5px 8px;
  border-radius: 999px;
  background: rgba(15, 23, 42, 0.08);
  color: #eef2ff;
  align-self: stretch;
  text-align: center;
  line-height: 0.7;
}

:deep(.uz-card__dept-label) {
  margin-top: 6px;
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.16em;
  opacity: 0.9;
}

:deep(.uz-card__emp-count) {
  margin-top: 4px;
  font-size: 11px;
  font-weight: 500;
}
:deep(.uz-card__emp-count.muted) {
  opacity: 0.7;
  font-style: italic;
}

/* O'ng tomoni */
:deep(.uz-card__right) {
  padding: 8px 9px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

:deep(.uz-card__top-row) {
  display: grid;
  grid-template-columns: 40px 1fr auto;
  column-gap: 8px;
  align-items: center;
}

:deep(.uz-card__avatar-wrap) {
  display: flex;
  align-items: center;
  justify-content: center;
}
:deep(.uz-card__avatar) {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #e5edff;
  object-position: top;
}

:deep(.uz-card__text) {
  min-width: 0;
}
:deep(.uz-card__name) {
  font-size: 13px;
  font-weight: 600;
  color: #0b1625;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
:deep(.uz-card__position) {
  font-size: 11px;
  color: #1d4ed8;
  margin-top: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
:deep(.uz-card__tabel) {
  font-size: 10px;
  margin-top: 2px;
  color: #6b7280;
}

:deep(.uz-card__actions) {
  display: inline-flex;
  flex-direction: column;
  gap: 4px;
}

:deep(.uz-btn.icon-btn) {
  width: 22px;
  height: 22px;
  border-radius: 999px;
  border: none;
  cursor: pointer;
  background: #eef2ff;
  color: #1d4ed8;
  font-size: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: background-color 120ms ease, transform 120ms ease;
}
:deep(.uz-btn.icon-btn:hover) {
  background: #dbeafe;
  transform: translateY(-1px);
}

/* Pastki qatordagi bo‘lim nomi */
:deep(.uz-card__bottom-row) {
  margin-top: 6px;
  font-size: 11px;
  text-align: center;
  color: #4b5563;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Hover / drag effektlar */
:deep(.uz-card:hover) {
  box-shadow: 0 12px 24px rgba(15, 23, 42, 0.12);
  border-color: rgba(37, 99, 235, 0.65);
}

:deep(.chart-container .node-content) {
  cursor: default;
}
:deep(.chart-container.ctrl-pressed .node-content) {
  cursor: grab;
}
:deep(.chart-container.is-dragging .node-content.dragging) {
  cursor: grabbing !important;
}

:deep(.chart-container.is-dragging .node-content:not(.dragging)) {
  filter: saturate(0.7) brightness(0.96);
  opacity: 0.9;
  transition: filter 120ms ease, opacity 120ms ease;
}

:deep(.node-content.dragging .uz-card) {
  transform: scale(1.03);
  box-shadow: 0 14px 26px rgba(0, 0, 0, 0.12),
    0 6px 12px rgba(0, 0, 0, 0.1);
  border-color: #2563eb;
}

:deep(.node-content.drop-target .uz-card) {
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.35);
  border-color: #1d4ed8;
}

:deep(.node-content.drop-commit .uz-card) {
  box-shadow: 0 0 0 3px rgba(22, 163, 74, 0.4);
  border-color: #16a34a;
}

:deep(.node-content.drop-target::after) {
  content: "Ctrl + Drag → yangi rahbar";
  position: absolute;
  bottom: 4px;
  right: 8px;
  font-size: 9px;
  background: #1d4ed8;
  color: #fff;
  padding: 1px 6px;
  border-radius: 999px;
  pointer-events: none;
}

:deep(.svg-chart-container) {
  width: 100%;
  max-height: 71vh;
}

/* Dialogdagi xodim preview */
.employee-preview {
  border-radius: 10px;
  border: 1px solid rgba(148, 163, 184, 0.4);
  background: #f9fafb;
}
.employee-preview .fw-semibold {
  font-size: 0.9rem;
}
.employee-preview .small {
  font-size: 0.75rem;
}
.teams-filter {
  /* max-width: 300px; */
  width: 40%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.teams-select {
  width: 100%;
  padding: 5px 12px;
  border-radius: 8px;
  border: 1px solid #dcdcdc;
  font-size: 14px;
  background-color: #fff;
  cursor: pointer;
  transition: all 0.2s ease;
}

.teams-select:focus {
  outline: none;
  border-color: #4f46e5;
  box-shadow: 0 0 0 2px rgba(79, 70, 229, 0.15);
}

.teams-select optgroup {
  font-weight: 700;
  font-size: 13px;
  color: #6b7280;
  background-color: #f9fafb;
}

.teams-select optgroup option {
  font-weight: 400;
  font-size: 14px;
  color: #111827;
  background-color: #ffffff;
  padding-left: 8px;
}

.btn-add-team-round {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 35px;           /* kichik kvadrat */
  height: 35px;
  background-color: #003974; /* yumshoq green */
  color: white;
  border: none;
  border-radius: 50%;    /* to‘liq yumaloq */
  cursor: pointer;
  font-size: 16px;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.btn-add-team-round:hover {
  box-shadow: 0 4px 8px rgba(0,0,0,0.15);
}

.btn-add-team-round:active {
  transform: scale(0.9);
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.no-data-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px 24px;
  border: 1px dashed #d1d5db;
  border-radius: 12px;
  background-color: #f9fafb;
  text-align: center;
  color: #374151;
  transition: all 0.2s ease;
}

.no-data-icon {
  font-size: 40px;
  margin-bottom: 12px;
}

.no-data-info h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #111827;
}

.no-data-info p {
  margin-top: 6px;
  font-size: 14px;
  color: #6b7280;
  max-width: 320px;
}
.no-data-info:hover {
  background-color: #f3f4f6;
  border-color: #9ca3af;
}

.modal-content {
  background-color: white;
  padding: 20px;
  border-radius: 10px;
  text-align: center;
}

.modal-content h3 {
  margin-bottom: 15px;
  font-size: 18px;
  color: #333;
}

.modal-content input {
  width: 100%;
  padding: 8px 10px;
  margin-bottom: 15px;
  border-radius: 6px;
  border: 1px solid #ccc;
  font-size: 14px;
}

.modal-actions {
  display: flex;
  justify-content: space-between;
  gap: 10px;
}

.btn-confirm {
  flex: 1;
  padding: 8px;
  background-color: #4caf50;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;
}

.btn-confirm:hover {
  background-color: #45a049;
}

.btn-cancel {
  flex: 1;
  padding: 8px;
  background-color: #f0f0f0;
  color: #333;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}

.btn-cancel:hover {
  background-color: #e0e0e0;
}

.attach-project {
  position: absolute;
  top: 10%;
  right: 25px;
  width: 20%;
  z-index: 1111;
}

.truncate-chip {
  max-width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Global styles.css yoki App.vue ichida <style> (scoped'siz) */
.swal-on-top {
  z-index: 99999 !important;
}

/* Tooltip va Pulse animatsiyalari */
.pulse-animation {
  animation: pulse-ring 1.5s infinite alternate;
}
@keyframes pulse-ring {
  0% { box-shadow: 0 0 0 0 rgba(59, 130, 246, 0.7); transform: scale(1); }
  100% { box-shadow: 0 0 0 8px rgba(59, 130, 246, 0); transform: scale(1.05); }
}

.pointer-tooltip-pulse {
  position: absolute;
  top: calc(100% + 12px);
  left: 50%;
  transform: translateX(-50%);
  background: #3b82f6;
  color: white;
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 13px;
  white-space: nowrap;
  animation: bounce 1s infinite alternate;
  pointer-events: none;
  z-index: 1000;
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
}
.pointer-tooltip-pulse::after {
  content: '';
  position: absolute;
  top: -10px;
  left: 50%;
  transform: translateX(-50%);
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent #3b82f6 transparent;
}
@keyframes bounce {
  from { transform: translate(-50%, 0); }
  to { transform: translate(-50%, 5px); }
}
</style>